module.exports = __webpack_public_path__ + "static/img/switchconfig.e8d7726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/switchconfig.png
// module id = zopC
// module chunks = 1